<div class="grid grid-cols-1 md:grid-cols-2 gap-6">
  @for (invitationUploadDocument of uploadDocumentsCategory(); track invitationUploadDocument.id) {
    <app-upload-document-card
      [directusInvitationUploadDocument]="invitationUploadDocument"
      [uploadedDocuments]="getFilteredDocs(invitationUploadDocument.id)"
      [isEditable]="isEditable()"
      (uploadDocument)="uploadDocument.emit($event)"
      (previewFile)="previewDocument.emit($event)"
      (downloadFile)="downloadDocument.emit($event)"
      (editDocument)="editDocument.emit($event)"
      (deleteFile)="deleteDocument.emit($event)"
    ></app-upload-document-card>
  }
</div>
